import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TranslationManager } from "../managers/translation.manager";
import { TranslationResponseDto } from "../../common/dtos/translation/translation.response";

@Injectable({
  providedIn: "root"
})
export class TranslationService {

  constructor(
        private translationManager: TranslationManager
  ) { }

  public getTranslations(): Observable<TranslationResponseDto> {
    return this.translationManager.getTranslations();
  }

  public getLanguages(lang: string): string | undefined {
    const langIds: Record<string, string> = {
      en: "2",
      it: "1",
      es: "3",
      fr: "4",
      pt: "5",
      ro: "6"
    };

    return langIds[lang];
  }
}